import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as styles from '../shared/CheckboxListFilter.module.css';

/**
 * MetricStatusFilter Component
 * Displays checkboxes for Metric Statuses (Status Filter)
 */
function MetricStatusFilter({ 
  metricStatuses = [], 
  selectedMetricStatuses = [],
  onMetricStatusesChange,
}) {
  const { t } = useTranslation();

  /**
   * Handle metric status checkbox change
   * @param {string} value - The status value
   */
  const handleMetricStatusChange = (value) => {
    const newSelection = selectedMetricStatuses.includes(value)
      ? selectedMetricStatuses.filter(s => s !== value)
      : [...selectedMetricStatuses, value];
    onMetricStatusesChange(newSelection);
  };

  return (
    <div className={styles.container}>
      <div className={styles.checkboxList}>
        {metricStatuses.length === 0 ? (
          <p className={styles.noStatusMessage}>{t('reports.filters.noStatusesAvailable')}</p>
        ) : (
          metricStatuses.map((status) => (
            <label key={status.value} className={styles.checkboxItem} htmlFor={`metric-status-${status.value}`}>
              <input
                id={`metric-status-${status.value}`}
                type="checkbox"
                className={styles.checkbox}
                checked={selectedMetricStatuses.includes(status.value)}
                onChange={() => handleMetricStatusChange(status.value)}
              />
              <span className={styles.checkboxLabel}>{status.label}</span>
            </label>
          ))
        )}
      </div>
    </div>
  );
}

MetricStatusFilter.propTypes = {
  metricStatuses: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  selectedMetricStatuses: PropTypes.arrayOf(PropTypes.string).isRequired,
  onMetricStatusesChange: PropTypes.func.isRequired,
};

export default MetricStatusFilter;

